import { AnimatePresence } from "framer-motion";
import React from "react";
import Layout from "./Layout";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/homepage/Home";
import Academics from "../pages/Academics";
import OurLeaders from "../pages/OurLeaders";
import Contact from "../pages/Contact";
import AboutUs from "../pages/AboutUs";
import OurPhilosophy from "../pages/OurPhilosophy";
import Alumni from "../pages/Alumni";
// import Facilities from "../pages/Facilities";
import NewsAndEvents from "../pages/NewsAndEvents";
import Achivements from "../pages/Achivements";
import Faculty from "../pages/Faculty";
import Gallery from "../pages/Gallery";
import Branches from "../pages/Branches";
import SmartClassroom from "../pages/facilities/SmartClassroom";
import ArtCraft from "../pages/facilities/ArtCraft";
import CCTV from "../pages/facilities/CCTV";
import KyanBoard from "../pages/facilities/KyanBoard";
import LearningLabs from "../pages/facilities/LearningLabs";
import MiddayMeal from "../pages/facilities/MiddayMeal";
import MusicRoom from "../pages/facilities/MusicRoom";
import PhysicalEducation from "../pages/facilities/PhysicalEducation";
import TuckShop from "../pages/facilities/TuckShop";
import LibraryRoom from "../pages/facilities/LibraryRoom";
import VisitorGuest from "../pages/VisitorGuest";
import Career from "../pages/Career";
import MedicalRoom from "../pages/facilities/MedicalRoom";
import CertificateViewer from "./CertificateViewer";
import NewsAndEventDetail from "../pages/NewsAndEventDetail"

import VisitorGuestDetail from "../pages/VisitorGuestDetail"
import CulturalTalentDetail from "../pages/CulturalTalentDetail";

const AnimatedRoutes = () => {
  return (
    <>
      <AnimatePresence mode="wait">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />}></Route>
            <Route path="our-leader" element={<OurLeaders />}></Route>
            <Route path="about-us" element={<AboutUs />}></Route>
            <Route path="our-philosophy" element={<OurPhilosophy />}></Route>
            <Route path="alumni" element={<Alumni />}></Route>
            <Route path="branches" element={<Branches />}></Route>
            {/* <Route path="facilities" element={<Facilities />}></Route> */}
            <Route path="news-and-events" element={<NewsAndEvents />}></Route>
               <Route path="news-and-events/:id" element={<NewsAndEventDetail />}></Route>

            <Route path="achievements" element={<Achivements />}></Route>
            <Route path="faculty" element={<Faculty />}></Route>
            <Route path="gallery" element={<Gallery />}></Route>
            <Route path="academics" element={<Academics />}></Route>
            <Route path="contact-us" element={<Contact />}></Route>
            <Route path="smart-classrooms" element={<SmartClassroom />}></Route>
            <Route path="art-craft" element={<ArtCraft />}></Route>
            <Route path="cctv-surveillance" element={<CCTV />} ></Route>
            <Route path="kyan-board" element={<KyanBoard />} ></Route>
            <Route path="learning-labs" element={<LearningLabs />} ></Route>
            <Route path="mid-day-meal" element={<MiddayMeal />} ></Route>
            <Route path="music-room" element={<MusicRoom />} ></Route>
            <Route path="medical-room" element={<MedicalRoom />} ></Route>
            <Route path="physical-education" element={<PhysicalEducation />} ></Route>
            <Route path="tuck-shop" element={<TuckShop />} ></Route>
            <Route path="library-reading-room" element={<LibraryRoom />} ></Route>
            <Route path="visitors-and-guests" element={<VisitorGuest />} ></Route>
            <Route path="visitors-and-guests/:id" element={<VisitorGuestDetail/>} ></Route>
            <Route path="career" element={<Career />} ></Route>

            <Route path="achievements/cultural-talent/:id" element={<CulturalTalentDetail/>} />


          </Route>
          <Route
            path="/certificate/:slug"
            element={<CertificateViewer />}
          />
        </Routes>
      </AnimatePresence>
    </>
  );
};

export default AnimatedRoutes;
